var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockReplaceV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 2.66675C8.64813 2.66675 2.66675 8.64813 2.66675 16.0001C2.66675 23.352 8.64813 29.3334 16.0001 29.3334C23.352 29.3334 29.3334 23.352 29.3334 16.0001C29.3334 8.64813 23.352 2.66675 16.0001 2.66675ZM16.0001 4.66675C18.7734 4.66675 21.2764 5.69573 23.2436 7.34253L7.34253 23.2423C5.69612 21.2752 4.66675 18.773 4.66675 16.0001C4.66675 9.72901 9.72901 4.66675 16.0001 4.66675ZM24.6576 8.75659C26.3044 10.7238 27.3334 13.2268 27.3334 16.0001C27.3334 22.2712 22.2712 27.3334 16.0001 27.3334C13.2271 27.3334 10.725 26.3041 8.75789 24.6576L24.6576 8.75659Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockReplaceV2);
export default __webpack_public_path__ + "static/media/blockReplaceV2.17488cbd75167d43c162286ce712e720.svg";
export { ForwardRef as ReactComponent };